/**
 * NOTE: Do not commit real credentials to version control.
 * Replace ${CLIENT_ID} and ${TENANT_ID} with environment variables or use Angular's fileReplacements
 * in angular.json to inject these values at build time.
 * For example, use a script or CI/CD pipeline to replace these placeholders before deployment.
 */
export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: 'a4cf5215-334d-4997-89e4-1e87e3d5f154',
      authority: 'https://login.microsoftonline.com/a0d2eaf1-c173-4688-905f-4b704f3d0eca',
      redirectUri: 'https://dev.evoluciona.vippinn.net.ar/auth/callback'
    }
  },
  apiConfig: {
    /* `User.ReadBasic.All` se pide **en el login** y no cuando hace falta.

       El permiso ya está consentido en el tenant, pero un token emitido sin
       ese scope no sirve para leer el directorio: pedirlo recién al buscar
       obliga a MSAL a renovar, y si no puede hacerlo en silencio la búsqueda
       falla la primera vez sin motivo entendible. Pidiéndolo desde el
       arranque, el token que ya está en la sesión alcanza. */
    scopes: ['openid', 'profile', 'email', 'User.Read', 'User.ReadBasic.All'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  },
  accountingApi: {
    baseUrl: 'https://dev.evoluciona.vippinn.net.ar',
    endpoints: {
      salesByAnalytic: '/api/',
      projects: '/api/projects',
      projectByCode: '/api/project',
      projectStatus: '/api/system/project/status',
      projectTypes: '/api/system/project/types',
      regions: '/api/system/regions',
      companies: '/api/system/companies',
      businessUnits: '/api/system/business_units',
      countries: '/api/system/countries',
      productTypes: '/api/system/product_types',
      responsiblesRoles: '/api/system/responsibles_roles',
      servicesTypes: '/api/system/services_types'
    }
  }
};
